export default __webpack_public_path__ + "static/gs-2b-reviewgeneratedcode-ca0a3df063846cdb4d5a769fcf45106e.webp";